import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';
import { Typography } from '@mui/material';
import { DashboardEventT } from './type';
import { useNavigate } from 'react-router-dom';
import DashboardEventContent from './DashboardEventContent';

function DashboardEvent({
    userDisplayName,
    type,
    widgetType,
    chartTitle,
    widget,
    dashboard,
    content,
}: DashboardEventT): React.ReactElement {
    const theme = useTheme();
    const navigate = useNavigate();
    const { t } = useTranslation();
    return (
        <>
            <Typography sx={{ marginTop: theme.spacing(1) }}>
                <Trans
                    i18nKey={`dashboardHistory.${type}`}
                    components={{
                        bold: (
                            <strong
                                style={{
                                    color: theme.palette.primary.main,
                                }}
                            />
                        ),
                        span: widget ? (
                            <strong
                                style={{
                                    color: theme.palette.primary.main,
                                    cursor: 'pointer',
                                }}
                                onClick={() =>
                                    navigate(
                                        `/dashboard/${dashboard.slug}#widget-${widget.key}`,
                                    )
                                }
                            />
                        ) : (
                            <strong
                                style={{
                                    color: theme.palette.primary.main,
                                }}
                            />
                        ),
                    }}
                    values={{
                        user: userDisplayName,
                        widgetType: t(
                            `dashboardHistory.widgetType.${widgetType}`,
                        ),
                        chartTitle: chartTitle,
                    }}
                />
            </Typography>
            <DashboardEventContent content={content} />
        </>
    );
}
export default DashboardEvent;
